import $ from 'jquery';
import CodeMirror from 'codemirror/lib/codemirror.js';
import 'codemirror/mode/yaml/yaml.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/addon/runmode/runmode.js'
import 'codemirror/addon/runmode/colorize.js'

export function prepareReadOnlyViews()
{
    CodeMirror.colorize($("pre.code"));
}


export function prepareEditor()
{
    var cm1;
    $("textarea.code").each(function()
    {
        var codeNode = this;
        var codemirror = CodeMirror.fromTextArea(codeNode,
            {
                theme: 'default',
                mode: $(codeNode).data('lang') || 'text/peml',
                indentUnit: 2,
                tabSize: 2,
                autoClearEmptyLines: true,
                fixedGutter: true,
                matchBrackets: true,
                viewportMargin: Infinity,
                /* autofocus: true, -- doesn't work */
                autofocus: false, /* to suppress error messages from trying */
                lineNumbers: true,
                lineWrapping: true
            });
        if (!cm1) { cm1 = codemirror; }
    });
    cm1.focus();
}


export function clearLineWidgets(editor)
{
    editor.widgets.forEach(function(widget)
    {
        editor.removeLineWidget(widget);
    });
    editor.widgets.length = 0;
}


export function addLineWidget(editor, msg, lineNumber, widgetType)
{
    var widget = $('<div class="widget ' + widgetType + '">' +
        '<i class="fa fa-times-circle"></i> ' + msg + '</div>');
    editor.widgets.push(editor.addLineWidget(lineNumber - 1, widget[0]));
}


/* $(document).ready(function() */
function loadCM()
{
    prepareReadOnlyViews();
    prepareEditor();

    var pf = document.querySelector("#peml-form");

    if (pf)
    {
        pf.addEventListener(
            'ajax:success',
            (event) => { prepareReadOnlyViews() });
    }
}


$(document).on("turbolinks:load", loadCM);
